import React, {
  Fragment,
  useState,
  useContext,
  useEffect,
  useRef,
} from "react";
import { useHistory } from "react-router-dom";
import AuthContext from "../../context/auth/AuthContext";
import AlertContext from "../../context/alert/AlertContext";
import ConfigContext from "../../context/config/ConfigContext";
import Preloader from "./../layout/Preloader";
import useForm from "../../hooks/useForm";
// import PopupMessage from "../common/PopupMessage";
import ReCAPTCHA from "react-google-recaptcha";
import usePageTitle from "../../hooks/usePageTitle";
import { Helmet } from "react-helmet";
import { env } from "../../env";

const ForgotPassword = (props) => {
  const alertContext = useContext(AlertContext);
  const authContext = useContext(AuthContext);
  const configContext = useContext(ConfigContext);

  const { getConfigValueByName, getConfigValueByCode } = configContext;
  const { setAlert, clearAlerts } = alertContext;
  const { loading, requestPasswordResetLink } = authContext;

  const history = useHistory();

  usePageTitle({
    appTitle: props.appTitle,
    pageTitle: "Password Reset",
  });

  const [user, setUser] = useState({ email: "" });
  const [labels, setLabels] = useState({ email: "" });
  const [captcha, setCaptcha] = useState(false);

  const { email } = user;
  const onChange = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const emailRef = useRef(null);

  useEffect(() => {
    window.scrollTo({
      top: 0,
    });
    clearAlerts();
    let email = getConfigValueByName("generalConfig", "Label", "label.email");
    setLabels({
      ...labels,
      email,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onCaptcha = (value) => {
    console.log(value);
    if (value) {
      setCaptcha(true);
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    clearAlerts();

    const user = { email };
    try {
      const res = await requestPasswordResetLink(user);
      console.log("Response: ", res);
      if (res.status === "ERROR") {
        const errorMsg = res.errorMessage
          ? res.errorMessage
          : getConfigValueByCode("generalConfig", "RESPONSE_MSG", res.msgCode);
        setAlert(errorMsg, "danger");
      } else {
        console.log(user);
        localStorage.setItem("user", JSON.stringify(user));
        console.log("Redireting to reset link: ");
        const msg = getConfigValueByCode("patronConfig", "RESPONSE_MSG", 474);
        setAlert(msg, "info");
        history.push("/reset-link");
      }
    } catch (err) {
      clearAlerts();
      // clearErrors();
      const msg = getConfigValueByCode("patronConfig", "RESPONSE_MSG", 475);
      setAlert(msg, "warning");
    }
  };

  const {
    Popup,
    validateField,
    validateAllFields,
    isFormValid,
    setIsFormValid,
  } = useForm({
    inputList: {
      email: emailRef,
    },
    screenName: "forgot_pasword",
  });

  useEffect(() => {
    const isValid = validateAllFields();
    setIsFormValid(isValid);
    console.log("Form is valid", isValid);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  return (
    <Fragment>
      <Helmet>
        <meta
          name="description"
          content="You’ll need a password to log in and reload your METRO Q® Fare Card or METRO Day Pass online. If you forgot it or need to set one up, click here."
        />
      </Helmet>
      <Popup role="alert" aria-relevant="all" />
      {loading && <Preloader />}
      <div
        className="publicView"
        role="main"
        ref={props.mainContentRef}
        tabIndex="-1"
      >
        <div className="publicView__PageTitleNote">
          <div> RESET ACCOUNT PASSWORD </div>
          <div className="publicView__pageTitle__note">
            {/* <span className="required">*</span>denotes a required field */}
          </div>
        </div>

        <div className="publicView__subPageTitleInfo">
          <p>
            Please enter your email address below and click or tap on the
            REQUEST PASSWORD LINK button.
          </p>
          <p>
            We’ll then email you a link you can use to either reset your
            existing password, or set up a password for the first time.
          </p>
        </div>

        <div className="publicView__formBody">
          <form noValidate autoComplete="off">
            {/* <div className="publicView__formGroup">
              <label htmlFor="firstname">
                {labels.firstname}
                <span className="required" aria-label="Input required">
                  *
                </span>
                :{" "}
              </label>
              <input
                type="text"
                name="firstname"
                className="form-control"
                placeholder={labels.firstname}
                onChange={onChange}
                value={firstname}
                onBlur={validateField}
                ref={firstnameRef}
                aria-required="true"
              />
              <div></div>
            </div>
            <div className="publicView__formGroup">
              <label htmlFor="lastname">
                {labels.lastname}
                <span className="required" aria-label="Input required">
                  *
                </span>
                :{" "}
              </label>
              <input
                type="text"
                name="lastname"
                className="form-control"
                placeholder={labels.lastname}
                onChange={onChange}
                value={lastname}
                onBlur={validateField}
                ref={lastnameRef}
                aria-required="true"
              />
              <div></div>
            </div> */}
            <div className="publicView__formGroup">
              <label htmlFor="email">
                {labels.email}
                <span className="required" aria-label="Input required">
                  (*Required)
                </span>
                :{" "}
              </label>
              <input
                type="text"
                name="email"
                className="form-control"
                placeholder={labels.email}
                onChange={onChange}
                onBlur={validateField}
                ref={emailRef}
                aria-required="true"
              />
              <div></div>
            </div>
            <ReCAPTCHA
              className="publicView__formGroup__google-captcha"
              aria-label="google captcha"
              sitekey={env.REACT_APP_HMW_GGL_RECAPTCHA_KEY}
              onChange={onCaptcha}
              onExpired={() => setCaptcha(false)}
            />
            <div className="publicView__actionGroup">
              <button
                type="submit"
                className="btn btn-block btn-primary publicView__actionGroup__submit-button"
                onClick={onSubmit}
                disabled={!(isFormValid && captcha)}
              >
                REQUEST PASSWORD LINK
              </button>
              <div></div>
              <div></div>
            </div>
          </form>
        </div>
      </div>
    </Fragment>
  );
};

export default ForgotPassword;
